/**
 * App Router created by karora on 11/03/17.
 */
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from './dashboard.component';
import { PersonResponsesComponent } from './persons/person-responses.component';
import { ProfileDetailComponent } from './profiles/profile-detail.component';
import { ProfilesComponent } from './profiles/profiles.component';
import { ProgrammeResponsesComponent } from './programmes/programme-responses.component';
import { ProgrammesComponent } from './programmes/programmes.component';
import { TopicResponsesComponent } from './topics/topic-responses.component';
import { TopicsComponent } from './topics/topics.component';

const routes: Routes = [
  { path: 'review', redirectTo: 'review/dashboard', pathMatch: 'full' },
  { path: 'review/dashboard', component: DashboardComponent },
  { path: 'review/responses/topic/:topicid', component: TopicResponsesComponent },
  { path: 'review/responses/person/:personid', component: PersonResponsesComponent },
  { path: 'review/topic/:topicid', component: TopicResponsesComponent },
  { path: 'review/topics', component: TopicsComponent },
  { path: 'review/wires', component: TopicsComponent },
  { path: 'review/programmes', component: ProgrammesComponent },
  { path: 'review/programme/:programmeid', component: ProgrammeResponsesComponent },
  { path: 'review/profiles', component: ProfilesComponent },
  { path: 'review/profile/:profiletype/:profileid', component: ProfileDetailComponent },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
